import { CheckFilledIcon, Flex } from '@iheartjane/reefer';

export const ValidationIcon = () => {
  return (
    <Flex ml={16} alignItems="center" justifyContent="center">
      <CheckFilledIcon color="system-positive-main" />
    </Flex>
  );
};
